import React, { Fragment, useState, useEffect } from 'react';
import BusinessHoursSection from './BusinessHoursSection';

function PymeBusinessHours({pyme}) {
  const [weekDays, setWeekDays] = useState([]);
  const [weekStartHours, setWeekStartHours] = useState({});
  const [weekEndHours, setWeekEndHours] = useState({});
  const [weekendDays, setWeekendDays] = useState([]);
  const [weekendStartHours, setWeekendStartHours] = useState({});
  const [weekendEndHours, setWeekendEndHours] = useState({});
  const [comments, setComments] = useState('');

  useEffect(() => {
    pyme &&
      pyme.businessHours &&
      pyme.businessHours.week &&
      setWeekDays(pyme.businessHours.week.days);

    pyme &&
      pyme.businessHours &&
      pyme.businessHours.week &&
      pyme.businessHours.week.hours &&
      pyme.businessHours.week.hours.start &&
      pyme.businessHours.week.hours.start.hhmm &&
      setWeekStartHours(pyme.businessHours.week.hours.start.hhmm);

    pyme &&
      pyme.businessHours &&
      pyme.businessHours.week &&
      pyme.businessHours.week.hours &&
      pyme.businessHours.week.hours.end &&
      pyme.businessHours.week.hours.end.hhmm &&
      setWeekEndHours(pyme.businessHours.week.hours.end.hhmm);

    pyme &&
      pyme.businessHours &&
      pyme.businessHours.weekend &&
      setWeekendDays(pyme.businessHours.weekend.days);

    pyme &&
      pyme.businessHours &&
      pyme.businessHours.weekend &&
      pyme.businessHours.weekend.hours &&
      pyme.businessHours.weekend.hours.start &&
      pyme.businessHours.weekend.hours.start.hhmm &&
      setWeekendStartHours(pyme.businessHours.weekend.hours.start.hhmm);

    pyme &&
      pyme.businessHours &&
      pyme.businessHours.weekend &&
      pyme.businessHours.weekend.hours &&
      pyme.businessHours.weekend.hours.end &&
      pyme.businessHours.weekend.hours.end.hhmm &&
      setWeekendEndHours(pyme.businessHours.weekend.hours.end.hhmm);

    pyme &&
      pyme.businessHours &&
      setComments(pyme.additionalComments);
  }, [pyme]);

  return (
    <Fragment>
      <BusinessHoursSection
        id="week"
        days={weekDays}
        startHour={weekStartHours}
        endHour={weekEndHours}
        title="Horario de atención semana laboral"
      ></BusinessHoursSection>
      <BusinessHoursSection
        id="weekend"
        days={weekendDays}
        startHour={weekendStartHours}
        endHour={weekendEndHours}
        title="Horario de atención fin de semana"
      ></BusinessHoursSection>
      {comments ? (
        <div className="row px-0 mx-0 mb-0 pt-0">
          <div className="d-flex flex-column w-100">
            <h5>
              <strong>Observaciones de atención</strong>
            </h5>
            <p>
              {comments.split('<br/>').map((line, index) => (
                <Fragment key={index}>
                  {line}
                  <br />
                </Fragment>
              ))}
            </p>
          </div>
        </div>
      ) : (
        ''
      )}
    </Fragment>
  );
}

export default PymeBusinessHours;
